import React, { useMemo } from 'react';
import BrokerMessageContent from 'components/rfq/quote/broker-message';
import BrokerMessagePageStore, { PageStoreContext } from 'store/pages/rfq/rfq-response/broker-message/pageStore';
import RFQStatusLayout from 'components/common/rfq/RFQStatusLayout';

const BrokerMessagePage: React.FC = () => {
  const pageStore = useMemo(() => new BrokerMessagePageStore(), []);

  return (
    <RFQStatusLayout>
      <PageStoreContext.Provider value={pageStore}>
        <BrokerMessageContent />
      </PageStoreContext.Provider>
    </RFQStatusLayout>
  );
};

export default BrokerMessagePage;
